import React from 'react';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ShareIdeaForm from '../../components/ShareIdea/ShareIdeaForm';

// Import banner image
// Using a generic inner banner or we can reuse one from other pages
import bannerbg from '../../assets/img/breadcrumbs/inner13.jpg';

const ShareIdeaMain = () => {
    return (
        <React.Fragment>
            <SiteBreadcrumb
                pageTitle="Share Your Idea"
                pageName="Start Project"
                breadcrumbsImg={bannerbg}
            />

            {/* Share Idea Form Section */}
            <ShareIdeaForm />

        </React.Fragment>
    );
}

export default ShareIdeaMain;
